export default {
  name: 'customer_national_id',
  component_path: 'modules/procedures/blocks/BlockInputNationalId',
  static_mandatory: ['minLength:11']
}